export const CONTACT_PHONE = '3402817105';
export const CONTACT_PHONE_FORMATTED = '+39 3402817105';
export const WHATSAPP_NUMBER = '393402817105';

export const buildWhatsAppLink = (message: string) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

export const WHATSAPP_DEFAULT_MESSAGE =
  'Ciao! Vorrei avere maggiori informazioni sulle lezioni private. In particolare mi interessano ripetizioni di materia per uno studente di Scuola,anno.';
export const WHATSAPP_LINK = buildWhatsAppLink(WHATSAPP_DEFAULT_MESSAGE);

export const WHATSAPP_UNIVERSITY_MESSAGE =
  'Ciao! Vorrei avere maggiori informazioni sulle lezioni universitarie.';
export const WHATSAPP_UNIVERSITY_LINK = buildWhatsAppLink(WHATSAPP_UNIVERSITY_MESSAGE);
